import { RouteParamsType } from '@/types';

export const CREATE_PAGE = 'create';

export const ROUTE_PARAMS_VARIABLE: RouteParamsType = {
  showroomId: 'showroomId',
  productId: 'productId',
  agentId: 'agentId',
};

export const ROUTE_PARAMS: RouteParamsType = {
  showroomId: `:${ROUTE_PARAMS_VARIABLE.showroomId}`,
  productId: `:${ROUTE_PARAMS_VARIABLE.productId}`,
  agentId: `:${ROUTE_PARAMS_VARIABLE.agentId}`,
};

// showrooms
export const SHOWROOMS_MANAGEMENT = '/showrooms';
export const SHOWROOMS_DETAIL = `${SHOWROOMS_MANAGEMENT}/${ROUTE_PARAMS.showroomId}`;

// products
export const PRODUCTS_MANAGEMENT = '/products';
export const PRODUCTS_DETAIL = `${PRODUCTS_MANAGEMENT}/${ROUTE_PARAMS.productId}`;

// brands
export const BRANDS_MANAGEMENT = '/brands';

// agents
export const AGENTS_MANAGEMENT = '/agents';
export const AGENTS_DETAIL = `${AGENTS_MANAGEMENT}/${ROUTE_PARAMS.agentId}`;

export const ROUTE_PAGES_URL: RouteParamsType = {
  showroomId: SHOWROOMS_DETAIL,
  productId: PRODUCTS_DETAIL,
  agentId: AGENTS_DETAIL,
};

export const SLUGS = {
  DASHBOARD: '/dashboard',
  // showrooms
  SHOWROOMS_MANAGEMENT,
  SHOWROOMS_DETAIL,
  // products
  PRODUCTS_MANAGEMENT,
  PRODUCTS_DETAIL,
  // configurations
  BRANDS_MANAGEMENT,
  // agents
  AGENTS_MANAGEMENT,
  AGENTS_DETAIL,
};
